import * as yup from 'yup';
import errorsText from '../../../utils/errorsText';

const validation = {
  fieldNames: {
    name: 'name',
    last_name: 'last_name',
    // code_melli: 'code_melli',
    // email: 'email',
    phone: 'phone',
    // shenasname_number: 'shenasname_number',
    image: 'image',
    shenasname_image : "shenasname_image"
  },
  defaultValue:{
    name : "",
    last_name : "",
    // code_melli : "",
    // email : "",
    phone : "",
    // shenasname_number : "",
    image : null,
    shenasname_image : null,
  },
  schema: (isEdit) => {
    const obj = {
      [validation.fieldNames.name]: yup.string().required(errorsText.blankError()),
      [validation.fieldNames.last_name]: yup.string(),
      // [validation.fieldNames.code_melli]: yup.string(),
      // [validation.fieldNames.email]: yup.string().required(errorsText.blankError()),
      // [validation.fieldNames.shenasname_number]: yup.string(),
      [validation.fieldNames.phone]: yup.string().required(errorsText.blankError()),
      [validation.fieldNames.image]: yup.mixed().required(errorsText.blankError()),
      [validation.fieldNames.shenasname_image]: yup.mixed().required(errorsText.blankError()),
    };

    return yup.object().shape(obj);
  },
};
// "Passwords must match"
export default validation;
